const windowWidth = window.innerWidth;

function loaddesktop() {
  let makerimages = document.querySelectorAll('.nh-maker-img-cols figure');
  let makerTextCols = document.querySelectorAll('.nh-maker-text-cols > div');

  imagesLoaded(makerimages, () => {
    for (let i = 0; i < makerimages.length; i++) {
      var delay = i * 200;
      window.setTimeout(function () {
        makerimages[i].classList.add('visible');
      }, delay);
    }

    for (let i = 0; i < makerTextCols.length; i++) {
      var delay = i * 200;
      window.setTimeout(function () {
        makerTextCols[i].classList.add('visible');
      }, delay);
    }
  });
}

function loadMobile() {
  let makerImagesHolder = document.querySelector('.maker-swiper');
  let makerimages = document.querySelectorAll('.maker-swiper figure,.maker-swiper .caption');
  let makerTextCols = document.querySelectorAll('.nh-maker-text-cols > div');

  imagesLoaded(makerImagesHolder, () => {
    for (let i = 0; i < makerimages.length; i++) {
      var delay = i * 200;
      window.setTimeout(function () {
        makerimages[i].classList.add('visible');
      }, delay);
    }

    for (let i = 0; i < makerTextCols.length; i++) {
      var delay = i * 200;
      window.setTimeout(function () {
        makerTextCols[i].classList.add('visible');
      }, delay);
    }
  });
}

if (windowWidth > 767) {
  loaddesktop();
} else {
  loadMobile();
}

window.addEventListener('resize', () => {
  const windowWidth = window.innerWidth;
  if (windowWidth > 767) {
    loaddesktop();
  } else {
    loadMobile();
  }
});

const swiper = new Swiper('.maker-swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  centeredSlides: true,
  initialSlide: 1,
  loop: true,
  spaceBetween: 10,
  speed: 600,
  effect: 'slide',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {},
});
